import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ElectricalLitigation from "../../components/Service/Subservice/electricalmatters";

import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function ElectricalLitigationPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Court Proceedings & Electrical Litigation"}/>
            <ElectricalLitigation/>
            <Footer/>
        </>
    )
}